import "./bootstrap/bootstrap.js";
import "./landrik/app.js";

const filters = document.querySelectorAll('.js-category-filter');

filters.forEach(filter => { 

  filter.addEventListener('click', function() {

    // highligh button
    filters.forEach(filterButton=>{
      if (filterButton.classList.contains('btn-info')) {
        filterButton.classList.remove('btn-info');
        filterButton.classList.add('btn-outline-info');
      }
    })

    setTimeout(function(){
  	 filter.classList.add('btn-info');
    }, 500); 
    // #highligh button


    let selectedFilter = filter.getAttribute('data-filter');
    let itemsToHide = document.querySelectorAll(`.js-filtered-items .js-filtered-item:not([data-filter='${selectedFilter}'])`);
    let itemsToShow = document.querySelectorAll(`.js-filtered-items [data-filter='${selectedFilter}']`);

    console.log(selectedFilter);

    if (selectedFilter == 'all') {
      itemsToHide = [];
      itemsToShow = document.querySelectorAll('.js-filtered-items [data-filter]');
    }

    itemsToHide.forEach(el => {
      el.classList.add('hide-source');
      el.classList.remove('show-source');
    });

    itemsToShow.forEach(el => {
      el.classList.remove('hide-source');
      el.classList.add('show-source'); 
    });

  });
});